var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "help" } }, [
      _c("div", { staticClass: "title" }, [_vm._v("用户协议")]),
      _c("div", { staticClass: "faq-page" }, [
        _c("p", [
          _vm._v(
            " 用戶体验有任何問題，请优先联系客服，KJcs2游戏使用许可及服务协议欢迎參閱KJcs2游戏软件和KJcs2游戏服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 本《KJcs2游戏使用许可及服务协议》（以下简称“本协议”，详细定义见下）由您（用戶）与KJcs2（本平台）共同缔结和签署 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 本协议具有合同效力，对协议双方均具有约束力。为保障您的合法权益，请仔细阅读并理解本协议的所有内容，尤其是免除KJcs2责任、限制您的权利、法律适用和争议解决等条款。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 您对前述条款的确认可能会给您带来限制、不便或损失，请您在确认同意本协议之前认真阅读前述条款。本协议适用于您使用KJcs2游戏软件（定义见下）和/或KJcs2游戏服务（定义见下）的全部活动。若您希望使用KJcs2游戏服务，则您应当阅读、同意并遵守本协议。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 您一旦点击“接受”、“同意”、“下一步”或具有同等含义的词语，或下载、安装、注册、开始使用任何KJcs2游戏软件或KJcs2游戏服务，则视为您已阅读并同意本协议的所有条款，本协议由此正式生效；若您不同意本协议的任何内容，或者无法准确理解本协议的任何条款，则请不要进行后续操作，并停止使用KJcs2游戏服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " KJcs2有权在必要时通过发布公告、在页面显著位置提示或向您发送书面通知等合理方式修改本协议。您在使用任何KJcs2游戏服务时，应当及时查阅了解修改的内容，并自觉遵守本协议的相关内容。若您继续使用KJcs2游戏服务，则视为对修改内容的同意，当发生与本协议有关的任何争议时，以最新的协议内容为准；若您不同意修改的内容，则请停止使用任何KJcs2游戏服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 确认您是具备完全民事权利能力和完全民事行为能力的自然人，有能力签署并遵守本协议，并对您使用KJcs2游戏服务的全部行为独立承担法律责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 若您未满18岁，或不具备前述主体资格，请在您的监护人的陪同下阅读本协议并由您的监护人对本协议的全部条款予以同意，在此情况下，您的监护人是本协议的协议方。 "
          ),
        ]),
        _c("p", [_vm._v("一、定义")]),
        _c("p", [
          _vm._v(
            " 1.1本协议：指本《KJcs2游戏使用许可及服务协议》，及本协议授引的《KJcs2用户注册协议》、《KJcs2用户隐私权保护政策和个人信息利用政策》及其他援引的协议、规则或通知，本协议同时包括《文化部网络游戏服务格式化协议必备条款》，本协议的前述内容为本协议不可分割的组成部分，与本协议正文具有同等法律效力。除本协议另有明确约定，您使用任何KJcs2游戏软件或KJcs2游戏服务均受本协议约束。本协议内容可由KJcs2通过发布公告、在页面显著位置提示或向您发送书面通知等合理方式不时更新和修改。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.2 您：指通过阅读并签署本协议而取得许可使用KJcs2游戏软件和KJcs2游戏服务的自然人，本协议下又称为“用户”或“玩家”。 "
          ),
        ]),
        _c("p", [
          _vm._v(" 1.3 KJcs2：指KJcs2游戏软件和/或KJcs2游戏服务的提供方。 "),
        ]),
        _c("p", [
          _vm._v(
            " 1.4KJcs2游戏：指KJcs2享有独立、完整知识产权或合法授权的任何网络游戏产品。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.5KJcs2游戏软件：指KJcs2通过其自有网站或平台，或其合作方网站或平台提供的KJcs2游戏的软件（包括适用于移动设备、计算机设备、电视设备、智能终端设备等终端设备，以APP、计算机软件、客户端、微端、网页、HTML5等形式呈现的任何适配版本），及其更新、升级、补丁。在适用的情况下，KJcs2游戏软件包括相关KJcs2游戏的网络服务器、网站、电子媒体、印刷材料和电子文档。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.6KJcs2游戏服务：指KJcs2提供的与KJcs2游戏软件相关的各项游戏运营服务。KJcs2游戏服务包括KJcs2游戏软件。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.7KJcs2游戏内容：指KJcs2游戏软件或KJcs2游戏服务包含的，或与之有关的，无论依据适用法律能否取得任何知识产权的任何名称、标题、标志、符号、设计、形象、服装、造型、图片、地图、道具、场景、音乐、台词、旁白、配音、故事叙述、动画、影音片段、源代码、目标代码、文档或任何其他类似元素或内容。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.8游戏数据：指您在使用KJcs2游戏和服务的过程中产生的各种数据，包括但不限于角色数据、等级数据、虚拟物品数据、虚拟货币数据、交流数据、位置信息、服务日志、通讯日志、行为日志、购买日志等数据。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.9游戏虚拟货币：为满足您在KJcs2游戏和服务中的正常交易、交流需求而提供的以特定数字单位表现的虚拟兑换工具，您可使用法定货币按一定比例直接或者间接购买，并用以兑换KJcs2游戏和服务内的其他虚拟物品或者增值服务。上述游戏虚拟货币仅得在KJcs2游戏和服务中使用和流通。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.10游戏虚拟物品：指可以在KJcs2游戏软件和/或KJcs2游戏服务中使用的虚拟物品，包括但不限于游戏角色、资源、游戏道具、技能、游戏装备、武器、坐骑、宠物。游戏虚拟物品可按一定的比例通过游戏虚拟货币兑换取得或免费取得。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.11测试服务器：KJcs2在其公布的测试阶段（包括但不限于封测、内测和公测）中向用户提供KJcs2游戏软件和KJcs2游戏服务的服务器。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.12体验服务器：KJcs2在KJcs2游戏中推出的测试最新版本游戏系统或游戏内容稳定性的服务器。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1.13适用法律：指对本协议任何条款和/或对其履行具有约束力的中华人民共和国的任何法律、行政法规、规章、国家（或地区）标准、行业标准、法院文书及其他有权机关发出的具有法律效力文书，包括但不限于《中华人民共和国网络安全法》、《网络游戏管理暂行办法》、《全国人民代表大会常务委员会关于加强网络信息保护的决定》、《文化部网络游戏服务格式化协议必备条款》、《文化部关于规范网络游戏运营加强事中事后监管工作的通知》、《关于保护未成年人身心健康实施网络游戏防沉迷系统的通知》、《文化部、商务部关于加强网络游戏虚拟货币管理工作的通知》。 "
          ),
        ]),
        _c("p", [_vm._v("二、游戏账号注册、使用与保管")]),
        _c("p", [
          _vm._v(
            " 2.1依据适用法律的相关规定，在您使用任何KJcs2游戏软件或KJcs2游戏服务前，您必需以本人的真实身份，并提供真实、完整、准确、有效的个人身份信息及相关信息实名注册KJcs2的帐号（以下简称“KJcs2账号”）或KJcs2认可的第三方账号（以下统称“游戏账号”）。您注册及使用KJcs2账号时，应当同意并遵守KJcs2发布并不时修改的《KJcs2用户注册协议》。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.2若您使用KJcs2认可的第三方帐号登录KJcs2游戏服务的，则您还应当遵守该第三方与游戏账号相关的协议和规则，并应保证该第三方帐号的稳定性、真实性及可用性。如因第三方帐号的原因（如第三方帐号被封号）致使您无法使用KJcs2游戏服务的，您应自行联系该第三方予以解决。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.3KJcs2有权依据适用法律的规定，审查您注册KJcs2账号时按需提供的个人身份信息是否真实、有效，并应积极采取技术与管理等合理措施保障您KJcs2账号的安全、有效；您有义务妥善保管游戏账号及密码，并正确、安全地使用游戏账号及密码，您对登录后所持游戏账号产生的行为依法享有权利和承担责任。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给您和他人的民事权利造成损害的，应当承担由此产生的法律责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.4您同意，您注册游戏账号时按需提供的个人身份信息和相关信息是认定您与游戏账号的关联性以及您身份的唯一依据，您应当依据适用法律的规定及本协议的约定对您提供的上述信息承担相应的法律责任。若您的个人身份信息发生变化，您应当及时予以更新。KJcs2应当及时、有效地为您提供相关修改服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.5若您未按适用法律及本协议的规定，按需实名注册游戏账户，或在注册游戏账户时未按需提供真实、准确、有效的个人身份信息，或未在个人身份信息变更时及时更新，则KJcs2有权拒绝或终止为您提供KJcs2游戏软件和/或KJcs2游戏服务，或对您的使用进行限制，或对您的游戏账号采取包括但不限于警告、限制或禁止使用全部或部分功能、删除游戏数据、删除相关信息、游戏账号封号、注销的处理措施。由此产生的相应法律后果由您自行承担。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.6您充分理解并同意，根据适用法律的相关规定，KJcs2有权将您的按需提供的个人身份信息提供给政府机构或与KJcs2合作的第三方机构进行比对和实名核验，以审查您提供的身份信息是否完整、真实、有效，并审查您是否年满18岁进而判断是否将您纳入防沉迷系统管理。您理解并同意，KJcs2对身份信息的更新和处理需要一定的时间，可能会存在已经年满18岁仍受到防沉迷限制的情况，KJcs2不为此承担任何责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.7若您发现您的游戏账号或密码被他人非法使用或存在使用异常的情况，您应当及时根据KJcs2公布的有效方式通知KJcs2，并告知KJcs2需要采取的措施。在此情况下，您应当提供与您注册时提供的身份信息相一致的个人有效身份信息。若经KJcs2核实信息一致的，KJcs2将根据您的要求并结合实际情况采取相应措施（包括但不限于暂停您账号的登录和使用），由此给您或他人造成的损失（如导致账户内虚拟物品或虚拟货币的使用期限届满等）由您自行承担。若您没有提供个人有效身份证件或者提供的个人有效身份证件与所注册的身份信息不一致的，KJcs2有权拒绝您的上述请求，由此给您或他人造成的损失，由您自行承担。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.8为了维护您的合法权益，若您需要KJcs2为您提供KJcs2账号注册人证明、原始注册信息等必要的协助和支持的，您应当向KJcs2提供与所注册时提供的身份信息相一致的个人有效身份信息。KJcs2将根据需要向有关行政机关和/和司法机关提供相关信息资料。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.9您不得以任何方式将您的游戏账号提供至他人使用，包括但不限于出售、赠予、转让、出借、出租，否则由此产生的一切法律后果由您自行承担。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2.10您理解并同意，若您连续365天未使用游戏账号登录KJcs2游戏，KJcs2有权在向您提前发出通知的情况下，采取注销账号、删除游戏数据和相关信息的措施，且您了解被删除的相关信息无法被恢复。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 三、用户信息收集与保护 3.1您同意并授权KJcs2为履行本协议，或为帮助您完成KJcs2账号的注册，或为提供、维护或改善KJcs2游戏软件和/或KJcs2游戏服务，或为本协议明确列明并要求您同意的其他目的，秉承合法、正当、必要的原则收集并使用您的用户信息，包括但不限于您在实名注册游戏账号时提供的信息、您在使用KJcs2游戏软件或KJcs2游戏服务的过程中上传或提供的信息、您的游戏数据、个人财产信息、游戏账号信息、虚拟交易信息、日志信息、设备信息、软件信息、使用语言、IP地址、位置信息，及您的其他相关信息（以下简称为“用户信息”）。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3.2KJcs2应当依据适用法律及本协议的规定，存储并采取适当的安全防护措施保护您的用户信息，以防止用户信息的丢失、不当使用、未经授权访问或披露。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3.3您了解并知悉，为方便您使用KJcs2游戏软件或KJcs2游戏服务，KJcs2或其合作方将使用cookies等技术，并将收集到的用户信息发送到对应的服务器。您可以选择接受或者拒绝cookies。如您拒绝cookies，则您有可能无法使用依赖于cookies的服务或者功能。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3.4 您知悉并理解，为实现本协议所述之目的，KJcs2可能向其合作伙伴或必要的其他第三方分享您的用户信息。 KJcs2分享您的用户信息均应当通过本协议或其他方式取得您的同意。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3.5您知悉并同意，KJcs2或其合作方有可能会利用KJcs2收集的信息向您发送有关商品促销、游戏服务或其他商业信息的电子邮件、短信、资讯或推送通知。若您不希望接受或继续接受相应信息，您可以按照KJcs2的相关提示选择取消订阅。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3.6未经您许可，KJcs2不会向任何第三方提供、公开或共享您注册资料中按需提供的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外： "
          ),
        ]),
        _c("p", [_vm._v("1)您或您的监护人授权KJcs2披露的；")]),
        _c("p", [_vm._v("2)有关法律要求KJcs2披露的；")]),
        _c("p", [_vm._v("3)司法机关或行政机关基于法定程序要求KJcs2提供的；")]),
        _c("p", [
          _vm._v("4)KJcs2为了维护自己合法权益而向您提起诉讼或者仲裁时；"),
        ]),
        _c("p", [_vm._v("5)应您的监护人的合法要求而提供您个人身份信息时。")]),
        _c("p", [
          _vm._v(
            " 3.7KJcs2游戏软件或KJcs2游戏服务为多人参与的公共环境，KJcs2提醒您在使用KJcs2游戏软件或KJcs2游戏服务中采取必要措施保护与您个人身份有关的信息，如拒绝向他人透露您的财产帐户、银行卡、信用卡及对应密码等重要资料和信息。否则因此产生的任何损失将由您自行承担。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3.8就用户信息的收集、使用和保护，KJcs2另行制定并发布了《KJcs2用户隐私权保护政策和个人信息利用政策》（以下简称“隐私政策”），该隐私政策是本协议的有机组成部分，对本协议双方均具有约束力。该隐私政策内容与本第三条约定相冲突的，以隐私政策的内容为准。KJcs2提示您仔细阅读该隐私政策的内容。 "
          ),
        ]),
        _c("p", [_vm._v("四、使用许可")]),
        _c("p", [
          _vm._v(
            " 4.1在您遵守本协议约定和适用法律规定的前提下，KJcs2授予您一项个人的、非商业性质的、可撤销的、可变更的、非排他性的、不可转让的、不可转授权的许可，授权您依据本协议的条款和条件，在以下授权范围内为非商业目的使用KJcs2游戏软件和KJcs2游戏服务： "
          ),
        ]),
        _c("p", [_vm._v("1)从KJcs2认可的渠道下载、更新、升级KJcs2游戏软件；")]),
        _c("p", [
          _vm._v("2)将前述KJcs2游戏软件安装至一台供您个人使用的终端设备；"),
        ]),
        _c("p", [
          _vm._v(
            "3)在前述终端设备上启动、显示、运行、登录、使用KJcs2游戏软件；"
          ),
        ]),
        _c("p", [
          _vm._v("4)在前述使用KJcs2游戏软件的过程中使用KJcs2游戏服务。"),
        ]),
        _c("p", [
          _vm._v(
            " 4.2本协议未授予您实施以下行为的许可，除非另行取得KJcs2的明确书面同意，您不得实施以下行为： "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1)复制、发行、传播、出售、出租、改编、出版KJcs2游戏软件，或利用KJcs2游戏软件或KJcs2游戏服务从事任何营利行为； 2)对任何KJcs2游戏内容进行复制、改编、传播、转载、汇编、出版、发行、表演、建立链接、建立镜像站点、直播、播放、展览、广播、翻译，或以第4.1条约定以外的方式使用任何KJcs2游戏内容； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3)对KJcs2游戏或KJcs2游戏服务进行反向工程、反向汇编、反向编译或者以其他方式尝试发现软件的源代码； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 4)超出第4.1条约定的许可范围，以任何方式使用KJcs2游戏软件/KJcs2游戏服务，和/或KJcs2游戏内容。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 4.3KJcs2通过其自有网站或平台，或其认可的网站或平台提供KJcs2游戏软件和/或KJcs2游戏服务，您仅可从前述渠道获取KJcs2游戏软件和/或KJcs2游戏服务。若您从未经KJcs2授权的第三方处下载、安装、登录、运行游戏或接受服务，将视为您未获得KJcs2的授权，KJcs2不保证相应游戏或服务的可用性，也不对其提供支持服务。若您或他人因此遭受损失，由您自行承担。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 4.4您知悉并理解，KJcs2仅提供KJcs2游戏软件和KJcs2游戏服务，除此之外与KJcs2游戏软件和KJcs2游戏服务有关的设备（如个人电脑、手机及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由您自行负担。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 4.5本协议未明示许可的一切权利均由KJcs2完整保留，您在行使这些权利时须另行取得KJcs2的事先书面许可，否则均可能依据适用法律的规定构成对KJcs2的侵权行为 。五、KJcs2游戏服务 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.1KJcs2可能会在KJcs2游戏软件或KJcs2游戏服务中向您提供收费项目和免费项目。对于收费项目，KJcs2有权决定并调整KJcs2游戏软件、KJcs2游戏服务、游戏虚拟货币、游戏虚拟物品的收费方式、资费标准或兑换比例，具体方式、标准和比例以KJcs2发布的内容为准；对于免费项目，KJcs2有权根据实际情况，对免费项目的设置、领取时间、具体内容、使用期限及使用方式等予以确定和变更，或决定对免费项目开始收费。一旦您选择下载KJcs2游戏软件、购买或自KJcs2处受赠游戏虚拟货币或游戏虚拟物品的使用权，或接受KJcs2提供的其他收费服务，即视为您已充分理解并接受相应的收费方式、资费标准和兑换比例。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.2为增加游戏的趣味性，KJcs2可能会在KJcs2游戏软件中发行游戏虚拟货币。游戏虚拟货币可能会通过系统赠送方式向您发放，也可能需要通过人民币或其他法定货币兑换所得，您由此取得游戏虚拟货币的使用权。游戏虚拟货币用于购买游戏虚拟物品的使用权或享受其他增值服务。KJcs2不提供游戏虚拟货币或游戏虚拟物品兑换成法定货币或实物的服务，但若KJcs2终止提供KJcs2游戏软件或KJcs2游戏服务的，则KJcs2会以法定货币或其他方式将尚未使用的游戏虚拟货币退还给您。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.3游戏虚拟货币和游戏虚拟物品的所有权由KJcs2所有，KJcs2将通过其认可的渠道发布游戏虚拟货币和游戏虚拟物品。对于您从未经授权的第三方处购买、转让、受赠、出租、出借或以其他方式获得的游戏虚拟货币或游戏虚拟物品的使用权或其他增值服务，KJcs2不保证其在KJcs2游戏软件中适用，也不对该等第三方的行为承担责任。对于您与第三方之间就前述交易产生的纠纷，由您自行与该等第三方解决。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.4游戏虚拟货币和游戏虚拟物品均可能具有使用期限、使用方式等方面的限制。在不具有法定免责事由或KJcs2无过错的情况下，若您未在指定期限内使用，或未按照指定方式使用，则可能会因过期、使用方式不当等原因而无法使用。此外，您了解并同意，在您违反本协议的约定或适用法律规定的情况下，KJcs2有权对您采取暂时或永久封停账号、限制或禁止使用部分或全部功能等措施，在此期间，您的游戏虚拟货币或游戏虚拟物品可能会过期。前述事项导致的损失均由您自行承担，KJcs2无需为此承担赔偿或补偿责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.5对于虚拟游戏货币的充值记录，KJcs2将按照适用法律要求的期限予以适当保存。对于其他游戏数据，除非适用法律有明确规定，KJcs2将自行决定其保存期间，且有权转移或清除部分历史游戏数据。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.6您知悉并理解，KJcs2游戏软件中可能存在强制对战的环节或区域，若您进入相应游戏环节或游戏区域，或点击“同意”、“接受”等带有认同含义的词语，即视为您已同意接受强制对战，并遵守相应的规则。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.7您了解并知悉，在KJcs2游戏软件或KJcs2游戏服务中，KJcs2可能会出于便利性考虑提供指向第三方的链接，或基于商业考量展示第三方投放的商业广告或推广信息。前述与第三方相关的链接、广告或其他信息均与KJcs2无关，KJcs2对于被链接内容的真实性、完整性或可靠性不做任何保证。您在利用或接触前述内容的过程中，需自行作出判断，KJcs2不对第三方的任何违约或侵权等行为承担责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.8您知悉并理解，在使用KJcs2游戏软件和/或KJcs2游戏服务过程中，可能存在或出现来自KJcs2无法控制的第三方的包括威胁性的、诽谤性的、令人反感的、非法的、侵犯他人合法权利（包括知识产权）的或类似的负面内容或行为，上述内容或行为均与KJcs2无关，KJcs2不承担由此产生的任何法律责任，但KJcs2存在过错或适用法律另有规定的除外。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.9您知悉并理解，KJcs2游戏软件和/或KJcs2游戏服务可能受软件BUG、版本更新缺陷、第三方病毒攻击或其他因素，而导致您游戏账号内的游戏数据、游戏虚拟货币和/或游戏虚拟物品等发生异常，在此情况下KJcs2有权冻结您的游戏账号并对异常原因进行查明。若查明相关异常系由您违反本协议约定的不正当行为造成，则KJcs2有权恢复您的账号至异常发生前的状态，或采取第6.3条规定的一项或多项相应措施。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.10为提升用户体验，您理解并同意，KJcs2将不定期通过发布软件升级包或软件补丁、在线升级等方式更新KJcs2游戏软件和/或KJcs2游戏服务。在此过程中，KJcs2可能会调取、收集您终端设备的软件版本信息等相关信息，并自动进行替换、修改、删除和/或补充。此种行为是软件更新所必须的一种操作或步骤，若您不同意KJcs2进行此种操作，请您不要进行更新，您使用的行为即视为您同意KJcs2进行此种操作。KJcs2在此提醒您部分更新为必要更新，若不更新则会无法登陆游戏，且新版本游戏或升级后服务的发布将可能导致旧版本游戏或升级前服务部分功能的缺失或不可用。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.11KJcs2为不同的终端设备或操作系统提供不同版本的KJcs2游戏软件和KJcs2游戏服务。不同终端设备和操作系统之间的客观差异可能会导致您在某终端设备中的游戏数据，如游戏虚拟货币或游戏虚拟物品无法成功地转移到另一终端设备之中。您了解前述差异并非由KJcs2造成，并知悉在不同操作系统或终端设备之间进行切换可能导致游戏数据损失的风险。若您仍然进行前述操作，则应自行承担相应责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.12若您为未成年人，KJcs2有权根据适用法律的规定、本协议的约定、其运营策略或您法定监护人的合理要求采取以下任一项或多项措施： "
          ),
        ]),
        _c("p", [_vm._v("1)向您的法定监护人提供您的游戏时长等游戏数据")]),
        _c("p", [_vm._v("2)限制或禁止您的游戏时长和消费额度；")]),
        _c("p", [_vm._v("3)限制或禁止您所能接触的游戏类型或具体功能；")]),
        _c("p", [_vm._v("4)根据您的累计游戏时长适用不同的游戏规则；")]),
        _c("p", [
          _vm._v(
            " 5)其他适用法律规定的、您的法定监护人提出合理理由要求采取的，或KJcs2认为可以采取的其他合理措施。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 5.13KJcs2游戏软件和KJcs2游戏服务以实际提供给您的情况和版本为准。考虑到您使用的游戏和服务涉及到互联网服务，可能会受到互联网各个环节不稳定因素的影响，包括但不限于不可抗力、病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因，KJcs2对以下内容不进行保证：KJcs2游戏软件和KJcs2游戏服务无错误及不会中断、所有缺陷已被更正、或KJcs2游戏软件和KJcs2游戏服务不会受到病毒或任何其他因素的损害。除非有法律明确规定，KJcs2在此明确声明不承担任何明示或默示的担保责任，包括但不限于对KJcs2游戏软件和KJcs2游戏服务的性能、适用性或不侵权的担保。 "
          ),
        ]),
        _c("p", [_vm._v("六、用户行为规范")]),
        _c("p", [
          _vm._v(
            " 6.1您在使用KJcs2游戏软件和KJcs2游戏服务的过程中，应当遵守本协议的约定，遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风俗和信息真实性等七条底线，不得发布含有以下内容的信息或从事相关违法行为： "
          ),
        ]),
        _c("p", [_vm._v("1)违反宪法确定的基本原则的；")]),
        _c("p", [_vm._v("2)危害国家统一、主权和领土完整的；")]),
        _c("p", [
          _vm._v("3)泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；"),
        ]),
        _c("p", [
          _vm._v(
            "4)煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；"
          ),
        ]),
        _c("p", [_vm._v("5)宣扬邪教、迷信的；")]),
        _c("p", [_vm._v("6)散布谣言，扰乱社会秩序，破坏社会稳定的；")]),
        _c("p", [_vm._v("7)宣扬淫秽、色情、赌博、暴力，或者教唆犯罪的；")]),
        _c("p", [_vm._v("8)侮辱、诽谤他人，侵害他人合法权益的；")]),
        _c("p", [_vm._v("9)违背社会公德的；")]),
        _c("p", [_vm._v("10)有法律、行政法规和国家规定禁止的其他内容的。")]),
        _c("p", [
          _vm._v(
            " 6.2除非适用法律允许或KJcs2事先书面同意，您不得在使用KJcs2游戏软件和KJcs2游戏服务过程中实施以下行为： "
          ),
        ]),
        _c("p", [
          _vm._v(
            "1)发送垃圾信息、邮件或利用游戏帐号帮助他人发送垃圾信息、邮件；"
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2)通过各种形式，如为游戏角色命名等方式发布或展示违反前述第6.1条规定的或其它不适当的文字、影音视频或其它内容，包括但不限于色情、暴力、低俗、恐怖、残忍等违背法律法规、社会公德或者民族优秀文化传统、风俗习惯的内容或病毒； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3)未经许可，获取或收集其他用户的电子邮件地址、通讯号码、身份证号码等用户信息； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 4)修改或遮盖KJcs2游戏软件或KJcs2游戏服务中涉及的任何KJcs2的服务名称、公司标志、商标或版权信息、其他知识产权声明或信息等内容； "
          ),
        ]),
        _c("p", [_vm._v("5)提供虚假的个人身份信息注册游戏账号")]),
        _c("p", [_vm._v("6)盗取他人的游戏账号、游戏虚拟货币或游戏虚拟物品等")]),
        _c("p", [_vm._v("7)注册多个游戏账户，以营利为目的进行游戏行为")]),
        _c("p", [
          _vm._v(
            " 8)教唆或实施与游戏账号、游戏虚拟货币、游戏虚拟物品等相关的私法交易，非法充值、为他人提供或雇佣他人提供游戏内服务（如“打钱”、“代练”等服务），或者提供交易中介服务、传播广告，或其它利用KJcs2游戏软件和/或KJcs2游戏服务牟取不当利益的行为； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 9)规避KJcs2可能采用的任何内容筛选技术，或访问您无权访问的任何服务或区域 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 10)通过各种方式、行为冒充KJcs2游戏系统或他人向其他用户散布或传播欺诈或虚假信息； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11)攻击、侵入KJcs2的网站和/或游戏服务器，或在集中时间段内以超出正常用户登录需求的高频率登录或尝试登录服务器从而使游戏服务器过载； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 12)对KJcs2游戏软件进行扫描、探查、测试，以检测、发现、查找其中可能存在的错误或漏洞，和/或利用前述错误或漏洞破坏KJcs2游戏软件的正常运行或牟取不当利益，和/或传播前述错误或漏洞 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 13)对KJcs2游戏软件进行反向工程、反向汇编、反向编译或者以其他方式尝试发现软件的源代码； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 14)通过非KJcs2开发的或未经授权的第三方软件、插件、外挂、系统，使用KJcs2游戏软件及KJcs2游戏服务，或制作、发布、传播任何形式的妨碍游戏公平性的辅助工具或程序（您同意以游戏程序中的监测数据和异常表现作为判断用户是否存在使用非法外挂等方法的行为）； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 15)建立有关KJcs2游戏软件或KJcs2游戏服务的镜像站点，或者进行网页快照，或者利用架设服务器等方式，为他人提供与KJcs2游戏软件和KJcs2游戏服务完全相同或者类似的服务； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 16)对游戏或服务过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经合法授权的第三方工具/服务接入软件和相关系统； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 17)修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论上述行为是否为商业目的； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 18)将KJcs2游戏软件或KJcs2游戏服务的任意部分，或KJcs2游戏内容的任意部分分离出来单独使用，或者进行其他的不符合本协议的使用； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 19)其他任何有违适用法律规定、本协议约定，或在行业内被广泛认为属于不正当行为，或其他不利于KJcs2游戏和其他用户的行为。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 6.3若您实施了违反适用法律或本协议禁止的任何行为，则KJcs2有权依据您违规行为的具体情节，并依据适用法律及本协议的规定决定对您采取以下一项或多项措施，并决定每一项措施的具体时限和内容 "
          ),
        ]),
        _c("p", [_vm._v("1)向您发出警告，多次警告可能会带来一定的后果")]),
        _c("p", [
          _vm._v(
            " 2)立即断开您当前使用的终端与游戏服务器之间的网络连接，您必须重新登录才能继续使用KJcs2游戏软件或服务； "
          ),
        ]),
        _c("p", [_vm._v("3)暂时或永久地禁止您在游戏中发表任何言论 ")]),
        _c("p", [
          _vm._v(
            " 4)限制或禁止使用部分或全部功能，如禁止您使用游戏中某項要求付费的功能，直至您清偿所欠费用并为继续使用上述付费功能而预先支付相应的费用之日止； "
          ),
        ]),
        _c("p", [
          _vm._v(
            "5)删除部分或全部游戏数据，如角色、积分、等级、装备、道具等；"
          ),
        ]),
        _c("p", [_vm._v("6)暂时或永久禁止您使用当前账号登录KJcs2游戏软件；")]),
        _c("p", [
          _vm._v("7)立即中止或终止向您提供KJcs2游戏软件和/或KJcs2游戏服务；"),
        ]),
        _c("p", [_vm._v("8)注销您的游戏账号；")]),
        _c("p", [
          _vm._v("9)解散游戏内组织，如帮派、工会、势力等具有同等性质的组织；"),
        ]),
        _c("p", [
          _vm._v(
            " 10)对于人物昵称、帮派名称、摊位名称、商店名称、宠物名称、召唤兽昵称、空间名称等可以由您自主命名的昵称或名称进行强制修改； "
          ),
        ]),
        _c("p", [_vm._v("11)将违规交易恢复至违规行为发生之前的状态；")]),
        _c("p", [
          _vm._v(
            " 12)扣除违规交易中，违规一方或违规双方所获得的游戏虚拟物品或游戏虚拟货币； "
          ),
        ]),
        _c("p", [
          _vm._v("13)冻结或收回游戏虚拟物品或游戏虚拟货币，限制其使用或转让；"),
        ]),
        _c("p", [
          _vm._v("14)屏蔽、删除或采用其他途径防止他人查看或分享您发表的言论；"),
        ]),
        _c("p", [_vm._v("15)要求您赔偿由此给KJcs2或他人带来的所有损失；")]),
        _c("p", [_vm._v("16)移交有关行政管理机关给予行政处罚；")]),
        _c("p", [_vm._v("17)追究您的刑事责任；")]),
        _c("p", [_vm._v("18)其他KJcs2认为合理的措施。")]),
        _c("p", [
          _vm._v("若您有任一账号存在违反本协议及其他相关规定的，KJcs2有权对您"),
        ]),
        _c("p", [_vm._v("的所有账号采取前述措施。")]),
        _c("p", [_vm._v("七、服务的中止与终止")]),
        _c("p", [
          _vm._v(
            " 7.1KJcs2出于执行行政/司法机关的命令、维护本服务的安全、维护其他用户的正常使用与数据安全、回应其他主体的侵权诉求等理由，或者KJcs2根据自身的判断，认为您的行为涉嫌违反本协议内容或KJcs2不时公布的使用规则等内容，或涉嫌违反适用法律的任何规定的，则KJcs2有权变更、中止、中断或终止向您提供KJcs2游戏软件和/或KJcs2游戏服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 7.2KJcs2有权依据以下约定中止或终止向您提供KJcs2游戏软件和/或KJcs2游戏服务： "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1)您有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，KJcs2应当立即终止向您提供KJcs2游戏服务； "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 2)您在接受KJcs2游戏服务时实施本协议第六条或其他条款中约定的任何不正当行为的，KJcs2有权终止向您提供KJcs2游戏服务。该等不正当行为的具体情形已在本协议中明确约定 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 3)您提供虚假注册身份信息，或实施违反本协议的行为，KJcs2有权中止向您提供全部或部分KJcs2游戏服务；KJcs2决定采取中止措施亦将通知您并告知中止期间，中止期间应当合理，中止期间届满KJcs2应当及时恢复对您的服务 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 4)KJcs2根据本7.2条的前述约定中止或终止对您提供部分或全部KJcs2游戏服务的，KJcs2应负举证责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 7.3发生以下任何情形时，KJcs2有权暂停、中止或终止KJcs2游戏软件和/或KJcs2游戏服务的全部或部分，KJcs2不对由此产生的不便或损害向您承担任何法律责任，但适用法律另有明确规定的除外： "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 1)游戏服务器的定期检查、维护、更新及其它相关软硬件的定期施工和更新； "
          ),
        ]),
        _c("p", [_vm._v("2)游戏服务器遭受损害，无法正常运作；")]),
        _c("p", [_vm._v("3)突发性的软硬件设备和/或电子通信设备故障；")]),
        _c("p", [_vm._v("4)网络提供商线路或其他故障；")]),
        _c("p", [
          _vm._v("5)在紧急情况之下依照适用法律的规定或为用户之人身安全；"),
        ]),
        _c("p", [_vm._v("6)第三方原因或其他不可抗力的情形。")]),
        _c("p", [
          _vm._v(
            " 7.4 KJcs2有权基于自身商业考虑，或在其认为必要的情况下，终止或部分终止任何KJcs2游戏软件和/或KJcs2游戏服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 在此情况下，KJcs2应当提前三十日予以公告，并按照适用法律的规定处理游戏终止运营的相关事宜。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 7.5您理解并同意，KJcs2游戏软件或KJcs2游戏服务因任何原因部分或全部终止，或者相关运营权发生转移时，KJcs2除按照适用法律规定，以法定货币形式或其它方式退回您已购买但未使用的游戏虚拟货币或游戏服务外，不对您不能再继续使用承担KJcs2游戏软件或KJcs2游戏服务任何赔偿或补偿责任。八、测试服务器和体验服务器8.1KJcs2可能会基于运营等商业考量推出测试服务器或体验服务器，您进入测试服务器或体验服务器使用KJcs2游戏软件或KJcs2游戏服务时，需要遵守本条款的特殊约定。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 8.2您了解并知悉，测试服务器和体验服务器与正式服务器仍有差距，可能会存在程序不稳定或数据丢失的情况，对于您在测试服务器或体验服务器中所遭受的损失，KJcs2不承担任何责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 8.3为实现测试和/或体验的目的，您同意KJcs2可以随时调控测试服务器或体验服务器内的游戏内容、游戏设置和用户数据，包括但不限于增加或删除游戏虚拟货币、游戏虚拟道具、游戏角色、游戏等级、游戏经验值等，或在测试阶段或体验阶段结束时删除全部游戏数据。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 8.4您了解并同意，KJcs2有权对您在测试服务器或体验服务器中的所有数据进行搜集、保存并用于改善KJcs2游戏软件和KJcs2游戏服务。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 8.5为保证测试或体验效果，KJcs2有权指定或限定用户进入测试服务器或体验服务器，且有权不定期关闭服务器或限时开放。 "
          ),
        ]),
        _c("p", [_vm._v("九、知识产权 ")]),
        _c("p", [
          _vm._v(
            " 9.1KJcs2游戏软件、KJcs2游戏服务及涉及的任何KJcs2游戏内容的任何及全部所有权、知识产权（包括但不限于专利及专利申请、商标及商标申请、著作权和/或邻接权、商业秘密及其他形式的受适用法律保护的知识产权）、权利和权益均归KJcs2完整享有，但其他权利人依法享有权利的除外。除本协议另有明确约定外，本协议不视为KJcs2向您转让或许可任何知识产权和/或其它权利。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 9.2您在使用KJcs2游戏软件或KJcs2游戏服务的过程中产生的游戏数据及其数据集合均属于KJcs2游戏服务的一部分，其全部所有权、知识产权、权利、利益均归属于KJcs2，KJcs2有权进行存储和利用。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 9.3KJcs2游戏软件和/或KJcs2游戏服务中可能会存在第三方的知识产权，若该第三方对您在KJcs2游戏软件或KJcs2游戏服务中使用该等知识产权有要求的，KJcs2将以适当的方式向您告知，您应当遵守相应要求，否则需承担相应法律后果。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 9.4您在使用KJcs2游戏软件或KJcs2游戏服务的过程中可能会上传、使用、传播您或者第三方享有知识产权的内容，KJcs2尊重前述知识产权，但您应当保证在上述内容上传或发布之前已经获得了相关权利人的合法授权，且上述授权与您履行本协议项下任何义务不存在冲突。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 9.5您在此授予KJcs2一项全球性、永久的、不可撤销、免费且可予转授权的许可，许可KJcs2使用、修改、复制、翻译、出版、传播、改变、发布、发行、发表、链接、公开表演、测试、公开传输、分发、自行或与合作伙伴共同推广或以其他适用法律允许的方式使用您所上传、发布的内容（包括但不限于文字、图片、音乐、表演和录音录像制品等）。 "
          ),
        ]),
        _c("p", [_vm._v("十、法律适用和争议解决")]),
        _c("p", [
          _vm._v(
            " 10.1本协议适用中华人民共和国的法律（不含冲突法）。当本协议的任何内容与中华人民共和国法律相抵触时，应当以法律规定为准，同时相关内容将按法律规定进行修改或解释，而本协议其他部分的法律效力不变。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 10.2本协议签订地武汉市东湖新技术开发区。如您和KJcs2就本协议的内容或其执行发生任何争议，应友好协商解决；协商不成时，双方同意交由本协议签订地具有管辖权的人民法院管辖。 "
          ),
        ]),
        _c("p", [_vm._v("十一、其他约定")]),
        _c("p", [
          _vm._v(
            " 11.1KJcs2对不可抗力导致的损失不承担责任。本协议所指不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机或互联网相关技术缺陷、互联网覆盖范围限制、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免并不能克服的客观情况。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.2您在使用KJcs2游戏软件和KJcs2游戏服务过程中应当遵守适用法律，并尊重当地的道德和风俗习惯。如果您的行为违反了适用法律或道德风俗，您应当为此独立承担责任。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.3根据国家新闻出版总署关于健康游戏的忠告，KJcs2提醒您：抵制不良游戏，拒绝盗版游戏；注意自我保护，谨防受骗上当；适度游戏益脑，沉迷游戏伤身；合理安排时间，享受健康生活。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.4KJcs2所有发给用户的通知可通过KJcs2游戏软件内、游戏官方网站或游戏官方论坛重要页面的公告、电子邮件或常规的电话、信件等形式传送。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.5本协议所有条款的标题仅为方便阅读，本身并无实际涵义，不能作为本协议及相关条款涵义解释的依据。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.6如本协议中的任何条款因任何原因被判定为完全或部分无效或不具有执行力的，本协议的其他条款仍应有效并且有执行力。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.7KJcs2不行使、未能及时行使或者未充分行使本协议或者按照适用法律所享有的权利，不应被视为放弃该权利，也不影响KJcs2在将来行使该权利。 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 11.8本协议自发布之日起实施，构成您和KJcs2之间就KJcs2游戏软件和KJcs2游戏服务的全部共识，并取代双方此前就相同事项达成的任何约定和理解。 "
          ),
        ]),
        _c("p", [_c("br")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }